export enum DisputeType {
    WithoutDispute,
    WithDispute
}